export const Units = {
  Meters: 'm',
  Feet: 'ft',
}
